var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaterResistance = function SvgWaterResistance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3700",
    transform: "translate(-167 -1759)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#ebebeb",
    "data-name": "Ellipse 679",
    transform: "translate(167 1759)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3585"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "m209.514 1791.711-7.71-10.326-7.71 10.326a9.607 9.607 0 1 0 15.42 0m0 0",
    "data-name": "Path 4412"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3586"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "m214.163 1789.96-5.073-6.794-5.073 6.794a6.321 6.321 0 1 0 10.146 0m0 0",
    "data-name": "Path 4412"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M209.09 1800.562a6.827 6.827 0 0 1-5.474-10.9l5.474-7.331 5.474 7.331a6.828 6.828 0 0 1-5.474 10.9m0-16.56-4.672 6.258a5.821 5.821 0 1 0 9.344 0Z",
    "data-name": "Path 4412 - Outline"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "m202.001 1819.619-.491-.17a32.75 32.75 0 0 1-12.174-7.126 25.2 25.2 0 0 1-6.235-9.64c-2.514-6.815-2.372-14.261-2.246-20.83.026-1.382.051-2.688.051-3.953v-1.5h1.5a28.9 28.9 0 0 0 10.335-1.7 23.55 23.55 0 0 0 8.207-5.3l1.053-1.017 1.046 1.017a23.55 23.55 0 0 0 8.208 5.305 28.9 28.9 0 0 0 10.337 1.7h1.5v1.5c0 1.264.025 2.57.051 3.952.125 6.569.267 14.015-2.247 20.83a25.2 25.2 0 0 1-6.228 9.636 32.75 32.75 0 0 1-12.175 7.126Zm-18.1-40.236c-.01.824-.026 1.665-.042 2.536-.12 6.3-.257 13.449 2.062 19.734a22.25 22.25 0 0 0 5.5 8.516 29.4 29.4 0 0 0 10.582 6.276 29.4 29.4 0 0 0 10.583-6.277 22.26 22.26 0 0 0 5.5-8.516c2.319-6.285 2.182-13.431 2.062-19.735-.017-.871-.033-1.712-.042-2.535-7.323-.259-13.138-2.462-18.1-6.858-4.968 4.392-10.782 6.595-18.105 6.859",
    "data-name": "Path 4413",
    opacity: 0.5
  }))));
};
export { SvgWaterResistance as ReactComponent };
export default "/_next/static/images/waterResistance.svg";